@let state = eclState();

<svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="30" height="22" rx="4" [attr.fill]="state.bgColor"/>
  <rect x="6" y="12" width="4" height="6" rx="1" [attr.fill]="state.level >= 1 ? state.color : defaultColor"/>
  <rect x="13" y="8" width="4" height="10" rx="1" [attr.fill]="state.level >= 2 ? state.color : defaultColor"/>
  <rect x="20" y="4" width="4" height="14" rx="1" [attr.fill]="state.level >= 3 ? state.color : defaultColor"/>
</svg>
